import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleContactRespose, IContact, ContactCreateEditRequest } from "../models/Contact";

export default function useContactsMutations() {
  const { get, post, put, postDocs, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation(
    (contact: ContactCreateEditRequest) => post(`/contact${contact.createAccountQuery ? `?createAccount=true` : ""}`, contact),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["contacts"]);
        queryClient.invalidateQueries(["accounts"]);
      },
    }
  );

  const update = useMutation(
    (_contact: ContactCreateEditRequest) => put(`/contact/${_contact.id}`, _contact),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["contacts"]);
        queryClient.invalidateQueries(["accounts"]);
      },
    }
  );


  const uploadDoc = useMutation(
    ({ data, contactId }: { data: any, contactId: string }) => postDocs(`/contact/${contactId}/documents`, data),
    {
      onSuccess: (data: any, variables: { data: any, contactId: string }) => {
        queryClient.invalidateQueries(["contactDocuments", variables.contactId]);
        return data;
      },
    }
  );

  return {
    create,
    update,
    uploadDoc,
  };
}
